import React, { useEffect, useState } from "react";
import '../index.css';
import Footer from "./footer";
import Navbar from "./navbar";
import { CheckCircle } from "lucide-react";

function Ordered() {
    const [animateIn, setAnimateIn] = useState(false);
    
    useEffect(() => {
        // Trigger animation after component mounts
        setTimeout(() => {
            setAnimateIn(true);
        }, 300);
    }, []);

    return (
        <div className="min-h-screen flex flex-col bg-gradient-to-b from-[#faf9f8] to-white">
            <Navbar />
            
            <div className="flex-grow flex flex-col items-center justify-center py-16 px-4">
                <div 
                    className={`bg-white rounded-lg shadow-md p-10 max-w-lg w-full text-center transition-all duration-700 transform ${
                        animateIn ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
                    }`}
                >
                    <div className="flex justify-center mb-6">
                        <div className={`transition-all duration-1000 transform ${
                            animateIn ? 'scale-100 rotate-0' : 'scale-0 rotate-180'
                        }`}>
                            <CheckCircle size={80} className="text-green-500" />
                        </div>
                    </div>
                    
                    <h1 className="text-3xl font-bold text-amber-900 mb-4">
                        Order Successful!
                    </h1>
                    
                    <p className="text-amber-800 text-lg mb-6">
                        Thank you for shopping with us. Your order has been confirmed and will be processed shortly.
                    </p>
                    
                    <div className={`border-t border-amber-200 pt-6 mt-6 transition-all duration-1000 delay-500 ${
                        animateIn ? 'opacity-100' : 'opacity-0'
                    }`}>
                        <p className="text-amber-700 mb-4">
                            A confirmation email has been sent to your registered email address.
                        </p>
                        
                        <div className="flex justify-center gap-4 mt-6">
                            <button 
                                className="px-6 py-2 bg-amber-100 hover:bg-amber-200 text-amber-900 rounded-md transition-colors duration-300"
                                onClick={() => window.location.href = '/orders'}
                            >
                               View Order
                            </button>
                            <button 
                                className="px-6 py-2 bg-amber-700 hover:bg-amber-800 text-white rounded-md transition-colors duration-300"
                                onClick={() => window.location.href = '/'}
                            >
                                Continue Shopping
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            
            <Footer />
        </div>
    );
}

export default Ordered;